import _momentTimezone from "./moment-timezone";
import _latest from "./data/packed/latest.json";
var exports = {};
var moment = exports = _momentTimezone;
moment.tz.load(_latest);
export default exports;